import { Trans } from '@lingui/macro'
import React from 'react'
import styled from 'styled-components/macro'
import { MEDIA_WIDTHS } from 'theme'
import { PositionDetails } from 'types/position'

import { IncentiveKey, IRewardInfo } from '../../interfaces'
import PositionListItem from './PositionListItem'

const DesktopHeader = styled.div`
  display: none;
  font-size: 14px;
  font-weight: 500;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.backgroundOutline};

  @media screen and (min-width: ${MEDIA_WIDTHS.deprecated_upToSmall}px) {
    align-items: center;
    display: flex;
    justify-content: space-between;
    & > div:last-child {
      text-align: right;
      margin-right: 12px;
    }
  }
`

const MobileHeader = styled.div`
  font-weight: medium;
  padding: 8px;
  font-weight: 500;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.backgroundOutline};

  @media screen and (min-width: ${MEDIA_WIDTHS.deprecated_upToSmall}px) {
    display: none;
  }

  @media screen and (max-width: ${MEDIA_WIDTHS.deprecated_upToExtraSmall}px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`

type PositionListProps = React.PropsWithChildren<{
  positions: PositionDetails[]
  setUserHideClosedPositions: any
  userHideClosedPositions: boolean
  hideClosedPositionsBtn?: boolean
  isStaked: boolean
  rewardInfoMap?: Record<string, IRewardInfo>
  incentiveKey: IncentiveKey | null
  handleUstake: (tokenId: string) => Promise<void>
  handleStake: (tokenId: string) => Promise<void>
  farmIsEnded?: boolean
  isUnstaked?: boolean
}>

export default function PositionList({
  positions,
  isStaked,
  rewardInfoMap,
  handleUstake,
  handleStake,
  incentiveKey,
  isUnstaked,
  farmIsEnded,
}: PositionListProps) {
  return (
    <>
      <DesktopHeader>
        <div>
          <Trans>Your positions</Trans>
          {positions && ' (' + positions.length + ')'}
        </div>
      </DesktopHeader>
      <MobileHeader>
        <Trans>Your positions</Trans>
      </MobileHeader>
      {positions.map((p) => (
        <PositionListItem
          isStaked={isStaked}
          isUnstaked={isUnstaked}
          key={p.tokenId.toString()}
          {...p}
          handleUnstake={handleUstake}
          handleStake={handleStake}
          rewardInfo={rewardInfoMap ? rewardInfoMap[p.tokenId.toString()] : undefined}
          farmIsEnded={farmIsEnded}
        />
      ))}
    </>
  )
}
